import Accordion from "./Classes/Accordion";
import Swiper from "swiper";
import {Navigation, Pagination} from "swiper/modules";
import Cv from "./Classes/Cv"
import ResponsiveTablesLight from "./Classes/ResponsiveTablesLight";
import Video from "./Classes/Video";
import CountUpNumbers from './Classes/CountUpNumbers';
import TableIconReplacer from "./Classes/TableIconReplacer";
import Lottie from "./Classes/Lottie";

var countUpInstance = null;

window.addEventListener("page_event_load", () => {

  new Lottie();
  new Cv();
  new TableIconReplacer();

  const countUpInstance = new CountUpNumbers({
    numbersSelector: '.lc-keyfigure__number',
    classIn: 'is-in-viewport',
    classOut: 'is-not-in-viewport',
    langArray: ['de', 'en'],
    decimalArray: ['.', '.'],
    thousandSepArray: ['’', '’'],
  });


  new Video();
  new Accordion({
    accordions: '.lc-accordion__inner-head',
    pxCorrectionMobile: 110,
    pxCorrectionDesktop: 105,
    mobileBreakpoint: 1025
  });

  new Swiper('.swiper', {
    modules: [Navigation, Pagination],
    loop: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: true,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  new ResponsiveTablesLight({
    tableComponentSelector: '.lc-component--table',
    tableContainerSelector: '.ns-table-container',
    tableSelector: '.lc-component--table table'
  });
});

window.addEventListener('note_event_load', evt => {
  document.body.classList.add("note-open");

  new ResponsiveTablesLight({
    tableComponentSelector: '.lc-component--table',
    tableContainerSelector: '.ns-table-container',
    tableSelector: '.lc-component--table table'
  });

});


window.addEventListener('note_unloaded', evt => {
  document.body.classList.remove("note-open");
});


//SUB in NAVIGATION - convert //

document.addEventListener("DOMContentLoaded", function () {
  function convertSubToHTML() {
    document.querySelectorAll("body.nav-open .iz-menu-b__link-text--level-1").forEach(element => {
      element.innerHTML = element.innerHTML.replace(/&lt;sub&gt;(.*?)&lt;\/sub&gt;/g, '<sub>$1</sub>');
    });
  }

  const bodyObserver = new MutationObserver(() => {
    if (document.body.classList.contains('nav-open')) {
      convertSubToHTML();
    }
  });

  bodyObserver.observe(document.body, {attributes: true, attributeFilter: ['class']});
  if (document.body.classList.contains('nav-open')) {
    convertSubToHTML();
  }
});

